export default {"src":"/_next/static/media/403_Leody.e19b737a.svg","height":241,"width":304};